import { type ModuleData, ModuleProvider, useModule } from '#providers'

export type FlowDeletedModuleData = ModuleData<{}, void, void>

export const FlowDeletedModuleProvider: typeof ModuleProvider<FlowDeletedModuleData> =
	ModuleProvider
export const useFlowDeletedModule: typeof useModule<FlowDeletedModuleData> =
	useModule
